import {Component, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {LangService} from '../../core/services/lang.service';
import {ReservationService} from '../../core/api/reservation.service';
import {getAppSectionName, getAppSectionUrl} from '../../shared/models/reservation.model';

@Component({
  selector: 'others-2',
  templateUrl: './others-2.component.html',
  imports: [DocumentViewerPageComponent]
})
export class Others2Component implements OnInit {
  title: string = '';
  url: string = '';

  constructor(private reservationService: ReservationService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.reservationService.getReservation().subscribe(reservation => {
      this.title = getAppSectionName(reservation, 1);
      this.url = getAppSectionUrl(reservation, 1);
    });
  }
}
